import { schedulingApi } from "./scheduling.api";

export const {
  useGetSchedulingsQuery,
  useLazyGetSchedulingsQuery,
  useGetSchedulingQuery,
  useSaveSchedulingMutation,
  useDeleteSchedulingMutation,
  useGetSchedulingsByOrderQuery,
  useGetDeletedSchedulingsByOrderQuery
} = schedulingApi;
